import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';

import moment from 'moment';
import { API_ENDPOINT } from '../../constants';
import ErrorModal_v2 from '../../components/errorModal_v2';

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}


class UpdateEventModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }



    setInitialData = () => {

    }



    componentDidMount() {
        this.setInitialData();


    }
    componentDidUpdate(prevProps, prevState) {


    }
    componentWillUnmount() {

    }

    toggle = (callback = null) => {
        if (this.props.toggle) {
            this.props.toggle(callback);
        }
    }
    formatDate = (date, format) => {
        if (!date || !format) return '';
        let dateString = date?.split(' ')?.[0];
        let timeString = date?.split(' ')?.[1];

        let DD = dateString?.split('/')[1];
        let MM = dateString?.split('/')[0];
        let YYYY = dateString?.split('/')[2];
        let HH = timeString?.split(':')[0];
        let mm = timeString?.split(':')[1];

        let formattedDate = format
            .replace('DD', DD)
            .replace('MM', MM)
            .replace('YYYY', YYYY)
            .replace('HH', HH)
            .replace('mm', mm);

        return formattedDate;

    }
    onConfirm = (forceUpdate = false, removeEventsForNotAvailableDoctors = false) => {
        const data = this.props.isOpen;
        const eventId = data?.event?._id;

        let from = {
            doctor: data?.oldItem?.data?.doctorId,
            startTime: this.formatDate(data?.oldItem?.data?.startTime, `${this.props.dateFormat} HH:mm`),
            endTime: this.formatDate(data?.oldItem?.data?.endTime, `${this.props.dateFormat} HH:mm`)
        };
        let to = {
            doctor: data?.newItem?.data?.doctorId,
            startTime: this.formatDate(data?.newItem?.data?.startTime, `${this.props.dateFormat} HH:mm`),
            endTime: this.formatDate(data?.newItem?.data?.endTime, `${this.props.dateFormat} HH:mm`)
        };

        let obj = {
            eventId,
            from,
            to,
            forceUpdate,
            removeEventsForNotAvailableDoctors
        }
        if (!obj?.eventId || !obj?.from?.doctor || !obj?.from?.startTime || !obj?.from?.endTime || !obj?.to?.doctor || !obj?.to?.startTime || !obj?.to?.endTime) return;

        this.setState({ loadingUpdate: true }, () => {
            fetch(API_ENDPOINT + `/data/calendar/events/update`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(parseJSON).then(({ result, status }) => {
                let setObj = {
                    loadingUpdate: false
                };
                if (result?.success && result?.eventId && this.props?.onSuccessUpdate) {
                    this.props.onSuccessUpdate(eventId);
                }
                this.setState(setObj, () => {
                    if (result?.checkProceedAnyway) {
                        this.setState({
                            errorOverlap: true
                        })
                    } else if (result?.error && result?.unavailableAdditionalDoctors?.length > 0) {
                        this.setState({
                            errorAdditionalDoctors: result?.unavailableAdditionalDoctors
                        })
                    } else {
                        this.toggle(() => {
                            let error = result?.error && !result?.unavailableAdditionalDoctors ? result?.error?.translate(this.props.lang) : null;
                            if (result?.errorAvailable?.clinicianName) {
                                const { clinicianName, minTime, maxTime } = result?.errorAvailable;
                                error = `${clinicianName} ${'is not available at this time'.translate(this.props.lang)}.`;
                                if (minTime && maxTime) {
                                    error += ` ${'Working hours:'.translate(this.props.lang)} ${minTime} - ${maxTime}`;
                                }
                            }
                            if (error) {
                                if (this.props.onError) this.props.onError(error);
                            }
                        });
                    }

                })

            }).catch(err => {
                console.log(err);
                this.setState({ loadingUpdate: false })
            })
        })


    }

    render() {
        const data = this.props.isOpen;
        const isOpen = this.props.isOpen ? true : false;

        if (!data) return null;

        const questionaryName = data?.event?.referralData?.questionaryName;
        const onlineVisit = data?.event?.referralData?.online;
        const caseNumber = data?.event?.referralData?.caseNumber;
        const patientName = data?.event?.referralData?.patientName;
        const title = data?.event?.title;
        const type = data?.event?.type;
        const eventHasReferral = (type === 'referral' || type === 'revisit') && data?.event?.referralData?.caseNumber ? true : false;

        let from = {
            doctor: data?.oldItem?.data?.doctorName,
            startDate: this.formatDate(data?.oldItem?.data?.startTime, this.props.dateFormat),
            startTime: this.formatDate(data?.oldItem?.data?.startTime, "HH:mm"),
            endDate: this.formatDate(data?.oldItem?.data?.endTime, this.props.dateFormat),
            endTime: this.formatDate(data?.oldItem?.data?.endTime, "HH:mm"),
        };
        from.start = this.props.lang === 'se' ? (from.startDate + ' kl: ' + from.startTime + ' - ' + from.endTime) : (from.startDate + ' ' + from.startTime + ' - ' + from.endTime);
        from.end = this.props.lang === 'se' ? (from.endDate + ' kl: ' + from.endTime + ' - ' + from.endTime) : from.endDate + ' ' + from.endTime;
        let to = {
            doctor: data?.newItem?.data?.doctorName,
            startDate: this.formatDate(data?.newItem?.data?.startTime, this.props.dateFormat),
            startTime: this.formatDate(data?.newItem?.data?.startTime, "HH:mm"),
            endDate: this.formatDate(data?.newItem?.data?.endTime, this.props.dateFormat),
            endTime: this.formatDate(data?.newItem?.data?.endTime, "HH:mm"),
        };
        to.start = this.props.lang === 'se' ? (to.startDate + ' kl: ' + to.startTime + ' - ' + to.endTime) : (to.startDate + ' ' + to.startTime + ' - ' + to.endTime);
        to.end = this.props.lang === 'se' ? (to.endDate + ' kl: ' + to.endTime + ' - ' + to.endTime) : to.endDate + ' ' + to.endTime;
        return (
            <>
                <Modal
                    isOpen={isOpen}
                    toggle={() => this.toggle()}
                    className='custom-calendar-update-event-modal'
                    centered
                >
                    <ModalHeader toggle={() => this.toggle()}>
                        {'Do you want to move:'.translate(this.props.lang)}
                    </ModalHeader>
                    <ModalBody>
                        <div className='case-info-wrap'>
                            <div className='case-info-left'>
                                <div className='case-title'>
                                    {
                                        eventHasReferral ?
                                            <>
                                                {questionaryName}{onlineVisit ? <span>{' - Online'.translate(this.props.lang)}</span> : ''}
                                            </>
                                            :
                                            title
                                    }
                                </div>
                                {
                                    eventHasReferral ?
                                        <div className='patient-name'>
                                            {'Patient'.translate(this.props.lang)}: <span>{patientName}</span>
                                        </div>
                                        :
                                        null
                                }

                            </div>
                            <div className='case-info-right'>
                                {
                                    eventHasReferral ?
                                        <div className='case-number'>
                                            {'Case ID'.translate(this.props.lang)}: <span>{caseNumber}</span>
                                        </div>
                                        :
                                        null
                                }

                            </div>
                        </div>
                        <div className='date-time-info-wrap'>
                            <div className='date-time-info red-text'>
                                <div className='date-time-info-title'>
                                    {'From'.translate(this.props.lang)}:
                                </div>
                                <div className='date-time-info-content'>
                                    <div className='date-time'>
                                        <span>{from.start}</span>
                                    </div>
                                    <div className='doctor-name'>
                                        <span>{from.doctor}</span>
                                    </div>
                                </div>

                            </div>
                            <div className='date-time-info green-text'>
                                <div className='date-time-info-title'>
                                    {'To'.translate(this.props.lang)}:
                                </div>
                                <div className='date-time-info-content'>
                                    <div className='date-time'>
                                        <span>{to.start}</span>
                                    </div>
                                    <div className='doctor-name'>
                                        <span>{to.doctor}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='action-buttons-wrap'>
                            <Button color="primary" className='red-button' disabled={this.state.loadingUpdate} onClick={() => this.toggle()}>{'Cancel'.translate(this.props.lang)}</Button>

                            <Button color="primary" className='green-button' disabled={this.state.loadingUpdate} onClick={() => this.onConfirm()}>{'Confirm'.translate(this.props.lang)}</Button>
                        </div>
                    </ModalBody>

                </Modal >

                {
                    this.state.errorOverlap ?
                        <Modal
                            isOpen={this.state.errorOverlap}
                            centered
                        >
                            <ModalBody className="delete-modal">
                                <div className='message'>
                                    {'Bookings in your calendar already exist for the selected period'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    color='primary'
                                    disabled={this.state.loadingUpdate}
                                    style={{ margin: 10, minWidth: 100 }}
                                    onClick={() => {
                                        this.onConfirm(true);
                                    }}>
                                    {'Continue anyways'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    disabled={this.state.loadingUpdate}
                                    style={{ margin: 10, minWidth: 100 }}
                                    onClick={() => {
                                        this.setState({
                                            errorOverlap: null
                                        }, () => {
                                            this.toggle();
                                        })
                                    }}>{'Go back'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.errorAdditionalDoctors ?

                        <ErrorModal_v2
                            lang={this.props.lang}
                            isOpen={this.state.errorAdditionalDoctors}
                            toggle={() => {
                                this.setState({ errorAdditionalDoctors: null })
                            }}
                            buttons={[
                                {
                                    text: 'Remove unavailable'.translate(this.props.lang),
                                    onClick: () => {
                                        this.onConfirm(false, true);
                                    }
                                },
                                {
                                    text: 'Select new term'.translate(this.props.lang),
                                    onClick: () => {
                                        this.setState({ errorAdditionalDoctors: null }, () => {
                                            this.toggle()
                                        })
                                    }
                                }
                            ]}

                        >
                            {'Some caregivers are not available at the selected term.'.translate(this.props.lang)}
                            {
                                this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.map((item, idx) => {
                                    return (
                                        <div>
                                            <span style={{ fontWeight: 600 }}>
                                                {item.doctorName}  {' - '}
                                            </span>
                                            <span style={{ color: 'red' }}>{'Unavailable'.translate(this.props.lang)}</span>
                                        </div>
                                    )
                                })

                            }
                            {"Do you want to remove unavailable caregivers or select a new term?".translate(this.props.lang)}
                        </ErrorModal_v2>
                        :
                        null
                }

            </>


        )
    }
}

export default UpdateEventModal;